import Ammo from 'ammojs-typed'
import camera from './camera'
import createBall from './objects/ball'
import createBase from './objects/base'
import createCastle from './objects/castle'
import createGround from './objects/ground'
import createRope from './objects/rope'
import blocksGenerator from './objects/blocks-generator'
import createWall from './objects/wall'
import initLights from './lights'
import initPhysics, {
  physicsWorld,
  setAmmo,
  rigidBodies,
  transformAux1,
} from './physics'
import state from './state'
import * as THREE from 'three'
import './index.css'
import {
  canvas,
  clock,
  container,
  controls,
  onWindowResize,
  renderer,
  scene,
  stats,
} from './utils'
import ee from './ee'
import {
  createParalellepiped,
  createRigidBody,
  createRandomColor,
  createMaterial,
} from './objects/utils'
import './info'

let cameraState
let delObjects = []
const objects = {
  arm: null,
  ball: null,
  base: null,
  ground: null,
  hinge: null,
  pos: null,
  pylon: null,
  quat: null,
  rope: null,
  ropeBody: null,
  ropePos: null,
}

ee.on('reset-level', () => {
  resetLevel()
})

Ammo().then(function (AmmoLib) {
  Ammo = AmmoLib
  setAmmo(Ammo)

  init()
  animate()
})

function incrementLevel() {
  state.game.level++
}

function getBricksOnFloorCount() {
  return rigidBodies.filter((o) => {
    return o.name == 'brick' && o.position.y < 1
  }).length
}

function updateScore() {
  setTimeout(function () {
    const bricksAfter = getBricksOnFloorCount()
    state.game.bricksKnocked = bricksAfter - state.game.bricksBefore
    state.game.score += state.game.bricksKnocked // Add to the score

    state.game.levelRound++

    if (state.game.levelRound == state.game.numRounds) {
      resetLevel()
    } else {
      resetLevelRound()
    }

    // console.log('state.game', state.game)
  }, 7500)
}

function init() {
  initGraphics()
  initPhysics()
  incrementLevel()
  createLevelObjects()
  createLevelInstanceObjects()
  createKnockDownObjects()
  initInput()

  cameraState = 'initial'
  state.game.bricksBefore = getBricksOnFloorCount()
  //console.log('physicsWorld', physicsWorld)
}

function initGraphics() {
  scene.background = new THREE.Color(0xbfd1e5)

  container.appendChild(renderer.domElement)
  //container.appendChild(stats.domElement)

  initLights()

  window.addEventListener('resize', onWindowResize, false)
}

// Objects that persist between levels
function createLevelObjects() {
  // Ground
  const { ground, pos, quat } = createGround()
  objects.ground = ground
  objects.pos = pos
  objects.quat = quat
}

// Objects that generate between levels
function createLevelInstanceObjects() {
  createBallAndBase()

  // Glue the rope extremes to the ball and the arm
  const influence = 1
  objects.ropeBody.appendAnchor(
    0,
    objects.ball.userData.physicsBody,
    true,
    influence,
  )
  objects.ropeBody.appendAnchor(
    state.objects.rope.segments,
    objects.arm.userData.physicsBody,
    true,
    influence,
  )
}

function createBallAndBase() {
  // Ball
  const ball = createBall(objects.pos, objects.quat)
  objects.ball = ball
  delObjects.push(ball)

  // Rope
  const { rope, ropePos, ropeSoftBody } = createRope(ball.position.clone())
  objects.rope = rope
  objects.ropeBody = ropeSoftBody
  objects.ropePos = { ...ropePos }
  delObjects.push(rope)

  // The base
  const { arm, base, hinge, pylon } = createBase({
    ball: objects.ball,
    ropePos: objects.ropePos,
    pos: objects.pos,
    quat: objects.quat,
  })

  objects.arm = arm
  objects.base = base
  objects.hinge = hinge
  objects.pylon = pylon
  delObjects.push(arm)
  delObjects.push(base)
  delObjects.push(pylon)
}

function createKnockDownObjects() {
  blocksGenerator({
    pos: objects.pos,
    quat: objects.quat,
  })
}

function initInput() {
  window.addEventListener(
    'keydown',
    function (e) {
      switch (e.keyCode) {
        // Space
        case 32:
          e.preventDefault() // Prevent page from scrolling down
          objects.ropeBody.set_m_anchors()
          updateScore()
          break

        // A
        case 65:
          state.objects.base.arm.movement = -2
          break

        // D
        case 68:
          state.objects.base.arm.movement = 2
          break

        // S
        case 83:
          state.objects.base.arm.movement = 0
          break
      }
    },
    false,
  )

  window.addEventListener(
    'keyup',
    function (e) {
      // Don't stop arm movement if its set to auto move
      if (e.keyCode == 32 && state.objects.base.arm.movement) {
        return
      }

      state.objects.base.arm.movement = 0
    },
    false,
  )
}

function animate() {
  requestAnimationFrame(animate)
  render()
  stats.update()
}

function cameraRotate() {
  switch (cameraState) {
    case 'initial':
      if (camera.position.y >= 18.75) {
        camera.position.x += 0.5
        camera.position.y -= 0.5
        camera.position.z -= 0.02
      } else {
        cameraState = null
      }

      break
  }

  //console.log('camera.position', camera.position)
}

function render() {
  const deltaTime = clock.getDelta()
  cameraRotate()
  updatePhysics(deltaTime)
  renderer.render(scene, camera)
}

function removeObjects(removeBricks = false) {
  // Remove bricks from previous level
  if (removeBricks) {
    rigidBodies = rigidBodies.filter((o) => {
      if (o.name == 'brick') {
        physicsWorld.removeRigidBody(o.userData.physicsBody)
        scene.remove(o)
        return false
      }

      return true
    })
  }

  //physicsWorld.removeRigidBody(objects.ground.userData.physicsBody)
  if (objects.ball) {
    physicsWorld.removeRigidBody(objects.ball.userData.physicsBody)
  }
  if (objects.rope) {
    physicsWorld.removeSoftBody(objects.rope.userData.physicsBody)
  }
  if (objects.arm) {
    physicsWorld.removeRigidBody(objects.arm.userData.physicsBody)
  }
  if (objects.pylon) {
    physicsWorld.removeRigidBody(objects.pylon.userData.physicsBody)
  }

  // Delete any objects marked to be deleted
  delObjects = delObjects.filter((o) => {
    scene.remove(o)

    return false
  })
}

function resetLevel() {
  state.game.levelRound = 0
  incrementLevel()
  removeObjects(true)
  createLevelInstanceObjects()
  createKnockDownObjects()
}

function resetLevelRound() {
  incrementLevel()
  removeObjects()
  createLevelInstanceObjects()
}

function updatePhysics(deltaTime) {
  // Hinge control
  objects.hinge.enableAngularMotor(
    true,
    (state.objects.base.arm.rotationSpeed / 10) *
      state.objects.base.arm.movement,
    50,
  )

  // Step world
  physicsWorld.stepSimulation(deltaTime, 10)

  // Update rope
  const softBody = objects.rope.userData.physicsBody
  const ropePositions = objects.rope.geometry.attributes.position.array
  const numVerts = ropePositions.length / 3
  const nodes = softBody.get_m_nodes()
  let indexFloat = 0

  for (let i = 0; i < numVerts; i++) {
    const node = nodes.at(i)
    const nodePos = node.get_m_x()
    ropePositions[indexFloat++] = nodePos.x()
    ropePositions[indexFloat++] = nodePos.y()
    ropePositions[indexFloat++] = nodePos.z()
  }

  objects.rope.geometry.attributes.position.needsUpdate = true

  // Update rigid bodies
  for (let i = 0, il = rigidBodies.length; i < il; i++) {
    const objThree = rigidBodies[i]
    const objPhys = objThree.userData.physicsBody
    const ms = objPhys.getMotionState()

    if (ms) {
      ms.getWorldTransform(transformAux1)
      const p = transformAux1.getOrigin()
      const q = transformAux1.getRotation()
      objThree.position.set(p.x(), p.y(), p.z())
      objThree.quaternion.set(q.x(), q.y(), q.z(), q.w())
    }
  }
}
